import { render } from "./Pa-Entertainment.vue?vue&type=template&id=d42ee822"
import script from "./Pa-Entertainment.vue?vue&type=script&lang=js"
export * from "./Pa-Entertainment.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__